import Box from '@mui/material/Box';
import React from 'react';
import { StyledLinkWithIcon } from '@/components/button/styles';
import { ExtraSmall } from '@/components/type';
import DownloadIcon from '@/components/icons/download-icon';

type AncapReportDownloadLinkProps = {
  href?: string;
};

const AncapReportDownloadLink = ({ href }: AncapReportDownloadLinkProps) => {
  if (!href) return null;

  return (
    <Box my={{ xs: 3, md: 4, lg: 6 }}>
      <StyledLinkWithIcon href={href} target="_blank" rel="noopener noreferrer">
        <ExtraSmall>Download ANCAP Report</ExtraSmall>
        <DownloadIcon />
      </StyledLinkWithIcon>
    </Box>
  );
};

export default AncapReportDownloadLink;
